<div appAddDocumentationLink>
  <router-outlet></router-outlet>
  <app-public-chat-support
    *ngIf="!router.url.includes('auth') && themeConfig.isAnalyticsMode != true"
  ></app-public-chat-support>
  <app-x-information-bar></app-x-information-bar>
  <app-download-app-overlay></app-download-app-overlay>
  <app-cookie-banner *ngIf="environment.eventTrackingEnabled == true" />
</div>
